module.exports = __webpack_public_path__ + "img/itx-drawer-right-toggle.56c81c19.svg";